import { Component, Input, inject } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { MdbNotificationRef } from 'mdb-angular-ui-kit/notification';

@Component({
  selector: 'app-toast',
  imports: [TitleCasePipe],
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
})
export class Toast {
  protected notificationRef = inject(MdbNotificationRef<Toast>);

  @Input() mode: 'success' | 'warning' | 'error' = 'success';
  @Input() message: string = '';
}